<template>
    <div class="shopPage">
        <ShopBack
            :centerText="'Store Details'"
            :shop_supplier_id="shop_supplier_id"
            :favorite-status="isFavorite"
            @favorite-updated="getSupplierDetail"
        />
        <div class="content-wrapper">
            <ShopSwiper :images="swiperImages"/>
            <van-sticky :offset-top="44"  >
            <div class="shopBox">
                <div class="menu">
                    <div v-for="item in menuData" :class="{ 'active':activeIndex == item.value}" class="menuItem" :key="item.value" @click="activeIndex = item.value">{{ item.label }}</div>
                </div>
            </div>
        </van-sticky>
        <!-- <ShopService/> -->
        <van-skeleton title  :row="10" :loading="loading">
            <div v-for="item in pageList">
                <component v-if="item.value == activeIndex" :is="item.page" :key="item.value" :data="item.data" :shop_supplier_id="shop_supplier_id"/>
            </div>
        </van-skeleton>
        </div>
    </div>
</template>
<script>
import myMixin from '@/utils/myMixin';
import ShopBack from '@/components/Shop/ShopBack.vue'
import ShopSwiper from '@/components/Shop/ShopSwiper.vue'
import ShopService from './service.vue'
import ShopInfo from './shopInfo.vue'
import ShopComments from './comments.vue'
import ShopTechnicians from './technicians.vue'
export default {
    name:'Shop',
    mixins: [myMixin],
    data(){
        return {
            activeIndex:2,
            loading:true,
            menuData:[
                {label:'Store Info',value:1},
                {label:'Services',value:2},
                {label:'Technicians',value:3},
            ],
            pageList:[
                // {page:ShopInfo,value:1,data:this.shopInfo},
                // {page:ShopService,value:2,data:this.shopService},
                // {page:ShopComments,value:3,data:null},
            ],
            shop_supplier_id:this.$route.query.shop_supplier_id,
            app_id:this.$route.query.app_id,
            swiperImages:[],
            isFavorite:false,
            shopInfo:{
            },
            shopService:{}
        }
    },
    components:{
        ShopBack,
        ShopSwiper,
        ShopService,
        ShopInfo,
        ShopComments,
        ShopTechnicians
    },
    created(){
        this.getSupplierDetail()
    },
    methods:{
        async getSupplierDetail(){
            const res  = await this.$api.getSupplierDetail({app_id:this.app_id,shop_supplier_id:this.shop_supplier_id})
                if(res.code == 1){
                    let detail = res.data && res.data.detail
                    this.isFavorite = !!(detail && detail.is_favorite)
                    this.shopService = detail.service || {}
                    if( Object.keys(detail).length > 0 ){
                        this.shopInfo = {
                            name: detail.name || detail.shop_name || '',
                            address: detail.address || detail.addr || detail.location || detail.address_detail || '',
                            sunday_start:detail.sunday_start || '00:00:00',
                            sunday_end:detail.sunday_end,
                            mondy_start:detail.mondy_start,
                            mondy_end:detail.mondy_end,
                            tuesday_start:detail.tuesday_start,
                            tuesday_end:detail.tuesday_end,
                            wednesday_start: detail.wednesday_start,
                            wednesday_end: detail.wednesday_end,
                            thursday_start: detail.thursday_start,
                            thursday_end: detail.thursday_end,
                            friday_start: detail.friday_start,
                            friday_end: detail.friday_end,
                            saturday_start: detail.saturday_start,
                            saturday_end: detail.saturday_end,
                            link_phone:detail.link_phone,
                            call_phone: detail.call_phone,
                            email: detail.email || '',
                            // 地图坐标：使用接口返回的经纬度
                            longitude: detail.longitude,
                            latitude: detail.latitude,
                            // 图片：使用接口返回，避免本地模拟地址
                            image: detail.image || [],
                            videos: detail.videos || []
                        }
                        if( detail.banner && detail.banner.length > 0 ){
                            this.swiperImages = detail.banner.map(item => this.getUrl(item.image.file_path))
                        }
                    }
                    this.pageList=[
                        {page:ShopInfo,value:1,data:this.shopInfo},
                        {page:ShopService,value:2,data:this.shopService},
                        {page:ShopTechnicians,value:3,data:null},
                    ]
                    this.loading = false
                }
        }
    }
}
</script>
<style lang="scss" scoped>
    .shopPage{
        width: 100%;
        box-sizing: border-box;
        .content-wrapper{
            ::v-deep .van-swipe{
                margin: 1rem 1rem 0.2rem 1rem;
            }
        }
        .shopBox{
            width: 100%;
            padding:0 1rem;
            box-sizing: border-box;
            .menu{
                display: flex;
                align-items: center;
                background: #F1F1F1;
                border-radius: .25rem;
                height: 2.375rem;
                font-size: .875rem;
                color: #1A3232;
                padding: .375rem;
                box-sizing: border-box;
                .menuItem{
                    width: calc(100% / 3);
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .active{
                    background: #1A3232;
                    color: #fff;
                    border-radius: .125rem;
                }
            }
        }
    }
</style>
